import React from "react"
// import { Link } from "gatsby"
// import {navigate} from 'gatsby'
// import "../Nav/Nav.scss"
// import { StaticImage } from "gatsby-plugin-image"//ローカルから画像を持ってくる
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import TargetBlankIcon from '../TargetBlankIcon/TargetBlankIcon.jsx'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons"
import {LinkButton} from '../index'
import * as styles from "./RecruitNav.module.scss";
import { AnchorLink } from "gatsby-plugin-anchor-links";

const menuItems = [
  { id: 1, text: "メッセージ", subText: "message", link: "/recruit#message", target: "" },
  { id: 2, text: "業務内容", subText: "works", link: "/recruit#works", target: "" },
  { id: 3, text: "先輩たちの声", subText: "voice", link: "/recruit#voice", target: "" },
  { id: 4, text: "環境と制度", subText: "culture", link: "/recruit#culture", target: "" },
  { id: 5, text: "募集要項", subText: "information", link: "/recruit#information", target: "" },
  { id: 6, text: "深川養鶏website", subText: "website", link: "/", target: "_blank" },
];

const RecruitNav = ({ pageName, ...props }) => {
  const breakpoints = useBreakpoint();
  // const navGatsby = (location)=>{
  //   navigate(location);
  // }
  return (
    <nav className={`Nav ${styles.RecruitNav}`}>
      <ul className={`Nav__list`}>
        {
        breakpoints.tb ?
          <li className={`Nav__listItem`}>
            <a href="/recruit/" className={`Nav__link`} rel="noreferrer">
              { breakpoints.tb ?
                <button onClick={props.closeModal}>
                  <strong>ホーム</strong>
                  <small>home</small>
                </button>
                :
                <>
                  <strong>ホーム</strong>
                  <small>home</small>
                </>
              }
              <span className={`iconWrp`}><FontAwesomeIcon icon={faChevronRight} /></span>
            </a>
          </li>
          :
          null
        }
        {menuItems.map((menuItem, i) => (
          <li key={i} className={`Nav__listItem`} data-current={(pageName === menuItem.subText) ? true : false} >
          {
            menuItem.target === "" ?
                <AnchorLink className={`Nav__link`} to={menuItem.link} title={menuItem.text}>
                  { breakpoints.tb ?
                    <button onClick={props.closeModal}>
                      <strong>{menuItem.text}</strong>
                      <small>{menuItem.subText}</small>
                    </button>
                    :
                    <>
                    <strong>{menuItem.text}</strong>
                    <small>{menuItem.subText}</small>
                    </>
                  }
                  {breakpoints.tb && pageName !== "footer" ? <span className={`iconWrp`}><FontAwesomeIcon icon={faChevronRight} /></span> : null}
                </AnchorLink>
              //--
              :
            <a href={menuItem.link} target={menuItem.target} className={`Nav__link`} rel="noreferrer">
              <strong>{menuItem.text}</strong>
              <small>{menuItem.subText}{menuItem.target === "_blank" ? <TargetBlankIcon /> : null}</small>
              {breakpoints.tb && pageName !== "footer" ? <span className={`iconWrp`}><FontAwesomeIcon icon={faChevronRight} /></span> : null}
            </a>
          }
           </li>
        ))}
        <li className={`${styles.RecruitNav__btn}`}>
          <LinkButton link={`/entry/`} target="">
            エントリー
          </LinkButton>
        </li>
      </ul>
    </nav>
  )
}

export default RecruitNav